'use strict';

define('GeoComplySvc',['lodash', 'PollingScheduler'], function (_, PollingScheduler) {

        function GeoComplySvc($window, $log, $q, $http, RequestContextHeaders, ConfigurationFac) {
            var geoClient = null, geoLicense = null;
            var GET_REGION_INTERVAL_MS = 60000, _getRegionScheduler;

            /**
             * Configures geoComply object to interact with its API and registers the necessary events
             * @private
             */
            function _setUpGeoComply() {
                if (locationContext && locationContext === 'nj' && angular.isDefined($window.GcHtml5)) {
                    geoClient = $window.GcHtml5.createClient(null, null);

                    geoClient.setReason('Awesome geoComply login for TVG');

                    $http({
                        method: 'GET',
                        url: ConfigurationFac.getBaseServiceUrl() + "/geo/v1/license",
                        headers: {
                            'X-ClientApp': clientApp,
                            Accept: 'application/json',
                            'x-tvg-context': RequestContextHeaders[clientApp + '_' + locationContext]
                        }
                    }).success(function (data) {
                        geoLicense = data.license;
                    });

                    // Register the onSuccess handler
                    geoClient.events.on('engine.success', function (text, xml) {
                        geoClient.events.emit('geoPacketAvailable', {success: {text: text, xml: xml}});
                    });

                    // Register error handler
                    geoClient.events.on('*.failed', function (code, message) {
                        geoClient.events.emit('geoPacketAvailable', {error: {code: code, message: message}});
                    });
                }
            }

            /**
             * Gets a geo packet for the user.
             * @param userId
             * @returns {*|promise}
             * @private
             */
            function _getGeoPacket(userId) {
                var deferred = $q.defer();

                if (!userId) {
                    return $q.reject({code: 0});
                } else {
                    if (geoClient && geoLicense) { //request GeoPacket

                        geoClient.events.once('geoPacketAvailable', function (data) {
                            if (data.success) {
                                deferred.resolve(data.success.text);
                            } else {
                                deferred.reject(data.error);
                            }
                        });

                        geoClient.setUserId(userId);
                        geoClient.setLicense(geoLicense);
                        geoClient.request();
                    } else {
                        $log.error('error getting GeoPacket. Client or license not present!');
                        return $q.reject({code: 0});
                    }
                }

                return deferred.promise;
            }

            function _getGeoClient() {
                return geoClient;
            }

            /**
             * Gets a list of Regions
             * @param latitude
             * @param longitude
             * @private
             */
            function _getGeoRegion(position){
                var deferred = $q.defer();
                if (_.isUndefined(position.coords.latitude) && _.isUndefined(position.coords.longitude)) {
                    $log.error('longitude is undefined!');
                    return $q.reject({code: 0});
                } else {
                    $http({
                        method: 'GET',
                        url: ConfigurationFac.getBaseServiceUrl() + "/geo/v1/regions/search/findByGpsCoordinate?latitude=" + position.coords.latitude + '&longitude=' + position.coords.longitude,
                        headers: {
                            'X-ClientApp': clientApp,
                            Accept: 'application/json',
                            'x-tvg-context': RequestContextHeaders[clientApp + '_' + locationContext]
                        }
                    }).success(function (data) {
                        deferred.resolve(data);
                    }).error(function(data, status) {
                        $log.error('error getting GeoRegion: ' + status + ' ' );
                        deferred.reject(data.error);
                    });
                    return deferred.promise;
                }
            }

            /**
             * Gets the geo position using the navigator.geolocation (only works in https)
             * @private
             */
            function _getPosition(callback) {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(function (position){
                        _getGeoRegion(position).then(function(data){
                            callback(data);
                        });
                    });
                } else {
                    $log.error('Geolocation is not supported by this browser.');
                }
            }

            /**
             * Initializes the _getRegionScheduler polling
             * @returns {*}
             * @private
             */
            function _initializeGetRegionPolling(callback){
                if (!_getRegionScheduler) {
                    _getRegionScheduler = new PollingScheduler(GET_REGION_INTERVAL_MS, function () {
                        _getPosition(function (data){
                            callback(data);
                        });
                    });
                }
                _getRegionScheduler.start();
            }

            return {
                getGeoPacket: _getGeoPacket,
                getGeoClient: _getGeoClient,
                initializeGetRegionPolling: _initializeGetRegionPolling,
                getPosition: _getPosition,
                setupGeoComply: _setUpGeoComply
            };

        }

        GeoComplySvc.$inject = [
            '$window',
            '$log',
            '$q',
            '$http',
            'RequestContextHeaders',
            'ConfigurationFac'
        ];

        return GeoComplySvc;
    }
)
;

